export default __webpack_public_path__ + "static/media/disposal.fb8a9352.png";